import type { PaginationPayload } from "react-admin";

import type { CustomerServiceOrganizationAccountsQuery } from "../generated/graphql";
import { paginate } from "./searchAndPaginate";

// A facility of the facilities list with the Salesforce account it is linked
// to. The account name is missing when the account is not in the CRM copy.
export type CustomerServiceOrganizationRow = {
  id: string;
  name: string | null;
  salesforceAccountId: string | null;
  salesforceAccountName: string | null;
};

export type CustomerServiceOrganizationFilter = {
  search?: string;
  unlinked?: boolean;
};

export const toCustomerServiceOrganizationRows = (
  accounts: CustomerServiceOrganizationAccountsQuery["customerServiceOrganizationAccounts"]
): CustomerServiceOrganizationRow[] =>
  accounts.map(account => ({
    id: account.organizationId,
    name: account.organizationName ?? null,
    salesforceAccountId: account.salesforceAccountId ?? null,
    salesforceAccountName: account.salesforceAccountName ?? null,
  }));

// Searches the facility and account names, case-insensitively, and keeps the
// backend's order.
export const filterCustomerServiceOrganizations = (
  rows: CustomerServiceOrganizationRow[],
  { search, unlinked }: CustomerServiceOrganizationFilter,
  pagination: PaginationPayload
): { data: CustomerServiceOrganizationRow[]; total: number } => {
  const term = search?.trim().toLowerCase() ?? "";
  const matches = rows.filter(
    row =>
      (!unlinked || !row.salesforceAccountId) &&
      (!term || [row.name, row.salesforceAccountName].some(value => value?.toLowerCase().includes(term)))
  );
  return paginate(matches, pagination);
};
